var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripesLeft = function SvgStripesLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMid",
    viewBox: "0 0 1617.337 1380.385",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1238.883 346.78l201.228-201.228",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.01 46.26l315.66-315.66",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M843.61 344.659l98.07-98.07",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M683.804 107.071l454.663-454.662",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M429.84 1155.823l201.23-201.229",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M332.967 855.302l315.66-315.66",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.568 1153.701l98.07-98.07",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-125.238 916.114l454.662-454.663",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.735 262.747L391.48 2",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M429.841 1155.822l201.23-201.228",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.736 262.746L391.482 2",
    stroke: "var(--color)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round"
  })));
};
export default SvgStripesLeft;